export enum StorageKeyBuilderStrategy {
  KEY_ONLY = 'keyOnly',
  KEY_USER = 'keyUser',
  KEY_USER_SESSION = 'keyUserSession'
}
